var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('SectionHero',{staticClass:"z-10 -md:!min-h-[calc(100svh_+_1px)] hero-main",attrs:{"variant":"transparent-fixed"}},[_c('Hero',{attrs:{"home":_vm.home}})],1),_vm._v(" "),_c('SectionDefault',[_c('Builder',{attrs:{"blocks":_vm.blocks,"context":{ titleAnimation: 'rotation' }}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }